type SelectProps = {
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  checked: boolean
}

export const Selector = ({ name, onChange, checked }: SelectProps) => {
  return (
    <div className="flex justify-between">
      <label htmlFor={name} className="text-base">
        {name}
      </label>
      <div className="pr-16">
        <input
          type="checkbox"
          data-name={name}
          name="transplant"
          value={name}
          onChange={onChange}
          className={'form-checkbox checkbox'}
          checked={checked}
        />
      </div>
    </div>
  )
}
